/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'rejectedCircle': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<defs><path pid="0" d="M8.028 1.333A6.674 6.674 0 0 1 14.695 8a6.674 6.674 0 0 1-6.667 6.667A6.674 6.674 0 0 1 1.361 8a6.674 6.674 0 0 1 6.667-6.667Zm2.195 3.529-5.334 5.333.944.943 5.333-5.333-.943-.943Z" id="svgicon_rejectedCircle_a"/></defs><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_rejectedCircle_a"/>'
  }
})
